// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Pp-z","imageAndVideoCount":"Qp-z","imageAndVideoContainer":"Rp-z","viewAllReviews":"Sp-z"};